"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hoverStyle = exports.GenericRangeCalendar = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var Calendar_1 = require("../../Calendar");
function GenericRangeCalendar(_a) {
    var isInTheRange = _a.isInTheRange, isInTheHoverRange = _a.isInTheHoverRange, startDate = _a.startDate, endDate = _a.endDate, onlyWeeks = _a.onlyWeeks, rest = __rest(_a, ["isInTheRange", "isInTheHoverRange", "startDate", "endDate", "onlyWeeks"]);
    var _b = react_1.useState(undefined), hoverDate = _b[0], setHoverDate = _b[1];
    var _c = react_1.useState({ start: undefined, end: undefined }), hoverWeek = _c[0], setHoverWeek = _c[1];
    var inRange = function (day) {
        return isInTheRange(day);
    };
    var inHoverRange = function (day) {
        return isInTheHoverRange(day, hoverDate);
    };
    var inWeekRange = function (week) {
        return isInTheRange(week.start) && isInTheRange(week.end);
    };
    var inHoverWeekRange = function (week) {
        return hoverWeek && isInTheHoverRange(week.start, hoverWeek.start) && isInTheHoverRange(week.end, hoverWeek.end);
    };
    var onMouseLeave = function (e) {
        if (onlyWeeks) {
            setHoverWeek({ start: undefined, end: undefined });
        }
        else {
            setHoverDate(undefined);
        }
    };
    if (onlyWeeks) {
        return (React.createElement(Calendar_1.Calendar, __assign({}, rest, { onMouseLeave: onMouseLeave, onWeekHover: setHoverWeek, modifiers: __assign(__assign({}, rest.modifiers), { inHoverWeekRange: inHoverWeekRange, inWeekRange: inWeekRange }), modifierStyles: __assign(__assign({}, rest.modifierStyles), { inHoverWeekRange: exports.hoverStyle, inWeekRange: Calendar_1.defaultModifierStyles.selected }), onlyWeeks: onlyWeeks })));
    }
    else {
        return (React.createElement(Calendar_1.Calendar, __assign({}, rest, { onMouseLeave: onMouseLeave, onDayHover: setHoverDate, isDaySelected: isInTheRange, modifiers: __assign(__assign({}, rest.modifiers), { inTheHoverRange: inHoverRange, inTheRange: inRange }), modifierStyles: __assign(__assign({}, rest.modifierStyles), { inTheHoverRange: exports.hoverStyle, inTheRange: Calendar_1.defaultModifierStyles.selected }), onlyWeeks: onlyWeeks })));
    }
}
exports.GenericRangeCalendar = GenericRangeCalendar;
exports.hoverStyle = function (theme) { return ({ background: theme.pallete.surface.background }); };
//# sourceMappingURL=GenericRangeCalendar.js.map